/*
 * Copyright (c) 2020. World Wide Generation Ltd
 */

import React, { useState } from 'react';
import ToolbarStatusButton from './ToolbarStatusButton';
import './ToolbarButton.scss';

export interface ToolbarButtonProps {
  contents: JSX.Element;
  btnClass?: string;
  tooltip?: JSX.Element | string;
  disabled?: boolean;
  onClick?: () => void;
  onMouseOver?: () => void;
  modal?: any;
}

const ToolbarButton = (props: ToolbarButtonProps) => {
  const { modal } = props;

  const [open, toggleOpen] = useState(false);

  const buttonProps = {
    ...props,
    onClick: modal ? () => toggleOpen(!open) : props.onClick,
  };

  const modalProps = {
    ...modal,
    isOpen: !!open,
    toggle: () => toggleOpen(!open)
  };

  return <div className='toolbar-button'>
    <ToolbarStatusButton {...buttonProps} active={open} />
    {modal && open ? <modal.component {...modalProps} /> : null}
  </div>
}

export default ToolbarButton;
